<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="邮箱：" prop="mail">
                <span>{{model.mail}}</span>
            </el-form-item>
            <el-form-item label="新用户姓名：" prop="new_name">
                <span>{{model.new_name}}</span>
            </el-form-item>
            <el-form-item label="新用户邮箱：" prop="new_mail">
                <span>{{model.new_mail}}</span>
            </el-form-item>
            <el-form-item label="新用户手机号：" prop="new_cellnum">
                <span>{{model.new_cellnum}}</span>
            </el-form-item>
            <el-form-item label="省份：" prop="province">
                <span>{{model.province}}</span>
            </el-form-item>
            <el-form-item label="城市：" prop="city">
                <span>{{model.city}}</span>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="是否回填：" prop="is_back">
                <span>{{model.is_back}}</span>
            </el-form-item>
            <el-form-item label="凭证图片：" prop="proof_img">
                <span>{{model.proof_img}}</span>
            </el-form-item>
            <el-form-item label="回填时间：" prop="back_time">
                <span>{{model.back_time}}</span>
            </el-form-item>
            <el-form-item label="是否处理：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'testDriveRecommendInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                mail: '',
                new_name: '',
                new_mail: '',
                new_cellnum: '',
                province: '',
                city: '',
                add_time: '',
                is_back: '',
                proof_img: '',
                back_time: '',
                state: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/testdriverecommend/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>